import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalContentService } from '../modal-content/modal-content.service';
import { ModalContentTypes } from '../constants/modal-content-types';
import { SignalsStoreService } from '../signals-store.service';
import { ResolutionService } from '../resolution.service';

@Component({
  selector: 'app-floating-donation-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './floating-donation-button.component.html',
  styleUrl: './floating-donation-button.component.scss'
})
export class FloatingDonationButtonComponent {
  private modalContentService = inject(ModalContentService);
  private signalStoreService = inject(SignalsStoreService);
  private resolutionService = inject(ResolutionService);

  shouldShowCartPreview = computed(() => this.signalStoreService.showCartPreview() && !this.resolutionService.isMobile());
  isInOrderComponent = computed(() => this.signalStoreService.isInOrderComponent());

  openDonationModal() {
    this.modalContentService.openModal(
      ModalContentTypes.VOLUNTARY_DONATION,
      {
        title: 'Make a Voluntary Donation',
        closeable: true
      }
    );
  }
}

